import { render, staticRenderFns } from "./RelatedContacts.vue?vue&type=template&id=06b91454&"
import script from "./RelatedContacts.vue?vue&type=script&lang=js&"
export * from "./RelatedContacts.vue?vue&type=script&lang=js&"
import style0 from "./RelatedContacts.vue?vue&type=style&index=0&id=06b91454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports